import { ToolboxComponent } from '../toolbox/ToolboxComponent'

/**
 * Annotation menu, used for showing tools like strong, link etc
 */
class AnnotationMenuComponent extends ToolboxComponent {
    getActiveToolGroupNames() {
        return ['overlay']
    }

    render($$) {
        const el = $$('div')
            .addClass('dw-toolbox-wrapper')

        if (!this.state.hints) {
            return el
        }

        if (this.state.active !== true) {
            el.addClass('dw-hidden')
        }

        let activeToolsEl = $$('div')
            .addClass('dw-toolbox')

        this.state.activeToolGroups.forEach((toolGroup) => {
            let toolGroupProps = Object.assign({}, toolGroup, {
                toolStyle: this.getToolStyle(),
                showIcons: true
            })
            activeToolsEl.append(
                $$(toolGroup.Class, toolGroupProps)
            )
        })

        return el.append(activeToolsEl)
    }

    didUpdate() {
        if (!this.state.hints) {
            return
        }

        let contentWidth = this.el.htmlProp('offsetWidth')
        let selRect = this.state.hints.selectionRect
        let selectionMaxWidth = selRect.width

        // By default, Overlays are aligned center/bottom to the selection
        this.el.css('top', selRect.top - 45)
        let leftPos = selRect.left + selectionMaxWidth / 2 - contentWidth / 2

        // Must not exceed left bound
        leftPos = Math.max(leftPos, 0)

        // Must not exceed right bound
        let maxLeftPos = selRect.left + selectionMaxWidth + selRect.right - contentWidth
        leftPos = Math.min(leftPos, maxLeftPos)
        this.el.css('left', leftPos)
    }
}

export {AnnotationMenuComponent}
